import React, { Component } from 'react';
import { Button, Icon, Image } from 'semantic-ui-react';

import { Box, Flex, Text } from 'src/Components/Base';
import { COLOR } from 'src/Components/Theme';

import { BrowseUniversityModal } from '../BrowseUniversity';

export const EmptyView = props => {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Box pb={3} style={{ maxWidth: 240 }}>
        <Image src="/emptyChooseFav.png" />
      </Box>
      <Text textAlign="center" pb={3}>
        คุณยังไม่ได้เลือกคณะในดวงใจ
      </Text>
      <BrowseUniversityModal
        trigger={
          <Button primary circular>
            <Icon name="plus" size="small" />
            <Text is="span" fontWeight="400" color={COLOR.white}>
              เพิ่มคณะในดวงใจ
            </Text>
          </Button>
        }
      />
    </Flex>
  );
};

export default EmptyView;
